import { Address, getAddressCodec, getAddressEncoder } from '@solana/kit';
import { keccak_256 } from '@noble/hashes/sha3';
import { MerkleTree } from 'merkletreejs';

/**
 * Creates a Merkle Tree from the provided data.
 */
function getMerkleTree(leaves: Address[], maxDepth: number): MerkleTree {
  const addressEncoder = getAddressEncoder();
  return new MerkleTree(
    [
      ...leaves.map((leaf) => addressEncoder.encode(leaf)),
      ...Array(2 ** maxDepth - leaves.length)
        .fill(0)
        .map(() => new Uint8Array(32).fill(0)),
    ],
    keccak_256
  );
}

/**
 * Creates a Merkle Proof for a given data item.
 *
 * This proof can be used to verify that the given
 * data item is part of the original data set.
 */
export function getMerkleProof(
  leaves: Address[],
  maxDepth: number,
  leaf: Address,
  index?: number
): Address[] {
  const addressCodec = getAddressCodec();

  return getMerkleTree(leaves, maxDepth)
    .getProof(Buffer.from(addressCodec.encode(leaf)), index)
    .map((proofItem) => addressCodec.decode(proofItem.data));
}
